import { Switch } from 'react-router-dom'

import ActivateAccountRoute from './routes/unauth/ActivateAccount'
import PasswordResetRoute from './routes/unauth/PasswordReset'
import PasswordExpiredRoute from './routes/unauth/PasswordExpired'
import EmailVerificationRoute from './routes/unauth/EmailVerification'
import MyProfileRoute from './routes/auth/MyProfile'
import SecurityQuestionRoute from './routes/auth/SecurityQuestion'
import MultiFactorAuthRoute from './routes/auth/MultiFactorAuth'
import ChangePasswordRoute from './routes/auth/ChangePassword'
import VerifyPhone from './routes/auth/VerifyPhone'
import PhoneSuccess from './routes/auth/PhoneSuccess'
import VerifyEmail from './routes/auth/VerifyEmail'
import EmailSuccess from './routes/auth/EmailSuccess'
import EmailUpdateSuccess from './routes/auth/EmailUpdateSuccess'
import AuthAppSuccessRoute from './routes/auth/AuthAppSuccess'
import NotFoundRoute from './components/NotFound'
import FAQsRoute from './routes/unauth/FAQs'
import FAQsAuthRoute from './routes/auth/FAQs'
import UpdateSuccessRoute from './routes/unauth/UpdateSuccess'
const Routes = () => {
  return <Switch>
    {UpdateSuccessRoute}
    {MyProfileRoute}
    {ChangePasswordRoute}
    {EmailVerificationRoute}
    {MultiFactorAuthRoute}
    {SecurityQuestionRoute}
    {ActivateAccountRoute}
    {PasswordResetRoute}
    {PasswordExpiredRoute}
    {VerifyPhone}
    {PhoneSuccess}
    {VerifyEmail}
    {EmailSuccess}
    {EmailUpdateSuccess}
    {AuthAppSuccessRoute}
    {FAQsRoute}
    {FAQsAuthRoute}
    {NotFoundRoute}
  </Switch>
}


export { Routes as default }